import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageRenderer from '../components/renderer/PageRenderer';
import SettingsLoader from '../components/common/SettingsLoader';
import MainAppWrap from '../Layout/MainAppWrap';
import SimpleHeader from '../components/SimpleHeader';
import { Container, Row } from 'react-bootstrap';
import Footer from '../components/Footer';

interface Schema {
    header?: {
        logo_url?: string;
        title?: string;
    };
    card_list?: any[];
    [key: string]: any;
}

const TestPage: React.FC = () => {
    const { pageId } = useParams<{ pageId: string }>();
    const [schema, setSchema] = useState<Schema | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!pageId) return;

        const isDev = (typeof window !== 'undefined') && (
            window.location.hostname.includes('dev-ept-ai.com') ||
            window.location.hostname.includes('localhost')
        );

        if (!isDev) {
            setIsLoading(false);
            setSchema({
                header: { title: 'Test Page Disabled (non-dev)' },
                card_list: [],
            });
            return;
        }

        const s3Url = `https://ept-ai-public-dev.s3.us-east-1.amazonaws.com/pages/${pageId}.json`;
        fetch(s3Url)
            .then((res) => res.json())
            .then((data) => {
                setSchema(data);
                setIsLoading(false);
            })
            .catch(() => {
                setSchema({
                    header: { title: `Not found: ${pageId}` },
                    card_list: [],
                });
                setIsLoading(false);
            });
    }, [pageId]);

    return (
        <div>
            <MainAppWrap>
                <div className="main-content">
                    {schema?.header ? (
                        <SimpleHeader logo={schema?.header?.logo_url} title={schema?.header?.title} />
                    ) : (
                        <SimpleHeader />
                    )}
                    <Container fluid="xxl" className="">
                        <Row>
                            <div className="page-container">
                                {isLoading ? <SettingsLoader /> : <PageRenderer schema={schema} />}
                            </div>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </MainAppWrap>
        </div>
    );
};

export default TestPage;

